export default "__VITE_ASSET__BiM1rbff__"